var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUserMessage)?_c('UserMessage',{attrs:{"id":`cwmsg-${_vm.message.id}`,"message":_vm.message,"reply-to":_vm.replyTo}}):(_vm.isActivityMessage)?_c('ActivityMessage',{attrs:{"id":`cwmsg-${_vm.message.id}`,"message":_vm.message}}):_c('AgentMessage',{attrs:{"id":`cwmsg-${_vm.message.id}`,"message":_vm.message,"reply-to":_vm.replyTo}})
}
var staticRenderFns = []

export { render, staticRenderFns }